/**
 * Zod praat standaard Engels. Dat lekte door in een verder Nederlands antwoord:
 * `?energielabels=ZZZ` gaf "Een of meer parameters kloppen niet." met daaronder
 * `Invalid option: expected one of "A+++++"|...`, en `?limiet=9999` leverde
 * "Too big: expected number to be <=500". Half vertaald leest slordiger dan
 * helemaal niet vertaald.
 *
 * Zod 4 levert zelf een Nederlandse tekstenbundel; die zetten we hier één keer
 * aan, in het gedeelde pakket, zodat API en web-app dezelfde zinnen tonen. Een
 * eigen melding bij een veld (`'Een buurt is een postcode van vier cijfers.'`)
 * wint nog steeds van de bundel.
 */
import { z } from 'zod';

let gezet = false;

export function zetNederlandseZodTeksten(): void {
  if (gezet) return;
  z.config(z.locales.nl());
  gezet = true;
}

zetNederlandseZodTeksten();
